import SuggestedActionItemWrapper from './SuggestedActionItemWrapper.component';

export default SuggestedActionItemWrapper;
